import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "./i18n";
import { currentLang, SUPPORTED_LANGS } from "./i18n";
import App from "@/App";

// First-visit browser language detection (skipped for search engine bots)
const isBot = /bot|crawler|spider|googlebot|bingbot|yandex|baidu|duckduck/i.test(navigator.userAgent);
const storedLang = localStorage.getItem("padsmash_lang");
if (!storedLang && !isBot) {
  const browserLang = (navigator.language || "fr").slice(0, 2).toLowerCase();
  const detected = SUPPORTED_LANGS.includes(browserLang) ? browserLang : "fr";
  localStorage.setItem("padsmash_lang", detected);
  if (detected !== "fr" && currentLang === "fr") {
    window.location.replace(`/${detected}${window.location.pathname}${window.location.search}`);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
